<template>
  <div>
    <v2-modal
      :show="show"
      title="Notification Preferences"
      size="md"
      @close="$emit('close')"
    >
      <div
        v-if="isLoading"
        class="v2-notification-prefs__loading"
      >
        <v2-spinner size="md" />
      </div>
      <div
        v-else
        class="v2-notification-prefs"
      >
        <div
          v-for="prefType in notificationPreferenceTypes"
          :key="prefType.key"
          class="v2-notification-prefs__item"
        >
          <label class="v2-notification-prefs__label">{{ prefType.label }}</label>
          <v2-dropdown
            :options="dropdownOptions"
            :value="notificationPreferences[prefType.key]"
            label-key="label"
            value-key="value"
            @select="$emit('update-preference', { key: prefType.key, value: $event })"
          />
        </div>
      </div>

      <template #footer>
        <v2-button
          variant="outline"
          @click="$emit('close')"
        >
          Cancel
        </v2-button>
        <v2-button
          :disabled="isSaving"
          :loading="isSaving"
          @click="handleSave"
        >
          Save
        </v2-button>
      </template>
    </v2-modal>

    <!-- Confirmation Modal for "All" notification -->
    <v2-modal
      :show="showConfirmation"
      title="Confirm Notification Access"
      size="sm"
      @close="showConfirmation = false"
    >
      <p class="v2-text-sm">
        Setting notifications to "All" will allow this user to receive every notification, even without access.
        Do you want to continue?
      </p>

      <template #footer>
        <v2-button
          variant="outline"
          @click="showConfirmation = false"
        >
          Cancel
        </v2-button>
        <v2-button
          variant="primary"
          @click="confirmSave"
        >
          Yes, Continue
        </v2-button>
      </template>
    </v2-modal>
  </div>
</template>

<script>
import V2Modal from '@/components/v2/V2Modal.vue'
import V2Button from '@/components/v2/V2Button.vue'
import V2Spinner from '@/components/v2/V2Spinner.vue'
import V2Dropdown from '@/components/v2/V2Dropdown.vue'

export default {
  name: 'V2NotificationPreferencesModal',
  components: {
    V2Modal,
    V2Button,
    V2Spinner,
    V2Dropdown,
  },
  props: {
    show: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    isSaving: { type: Boolean, default: false },
    notificationPreferences: { type: Object, default: () => ({}) },
    originalNotificationPreferences: { type: Object, default: () => ({}) },
    selectedTeammate: { type: Object, default: null },
    notificationPreferenceOptions: { type: Array, default: () => [] },
    notificationPreferenceTypes: { type: Array, default: () => [] },
    getNotificationPreferenceLabel: { type: Function, default: v => v },
    requiresConfirmation: { type: Function, default: () => false },
  },
  data() {
    return {
      showConfirmation: false,
    }
  },
  computed: {
    dropdownOptions() {
      return this.notificationPreferenceOptions.map(opt => ({
        label: opt.label,
        value: opt.key,
      }))
    },
  },
  methods: {
    handleSave() {
      if (this.selectedTeammate && this.requiresConfirmation(this.selectedTeammate)) {
        this.showConfirmation = true
      } else {
        this.$emit('save')
      }
    },
    confirmSave() {
      this.showConfirmation = false
      this.$emit('save')
    },
  },
}
</script>

<style lang="scss" scoped>
.v2-notification-prefs {
  display: flex;
  flex-direction: column;
  gap: var(--v2-space-4);

  &__loading {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: var(--v2-space-6);
  }

  &__item {
    display: flex;
    flex-direction: column;
    gap: var(--v2-space-1);
  }

  &__label {
    font-size: 0.875rem;
    font-weight: 600;
    color: var(--v2-foreground);
  }
}
</style>
